import { createGenericApiSlice } from '../../../Api/Factory/genericApiFactory';
import { TagTypes } from '../../../Api/Types/tagTypes';
import {
  Reservation,
  CreateReservationCommand,
  UpdateReservationCommand,
  CreateReservationResponse,
} from '../Types/reservationTypes';

const baseReservationsApi = createGenericApiSlice<
  Reservation,
  CreateReservationCommand,
  UpdateReservationCommand,
  CreateReservationResponse
>({
  reducerPath: 'reservationsApi',
  tag: TagTypes.Reservation,
  endpoint: 'reservations',
});

export const reservationsApi = baseReservationsApi.enhanceEndpoints({
  addTagTypes: [TagTypes.ReservationPayment, TagTypes.CashDocument],
});

export const {
  useGetAllQuery: useGetReservationsQuery,
  useGetByIdQuery: useGetReservationByIdQuery,
  useCreateMutation: useCreateReservationMutation,
  useUpdateMutation: useUpdateReservationMutation,
  /**
   * Calls `DELETE /reservations/{id}`. The backend now performs an idempotent soft-cancel
   * (transitions `status` to `cancelled`) instead of a physical delete; the reservation row
   * remains readable afterwards. Contract/signature unchanged.
   */
  useDeleteMutation: useDeleteReservationMutation,
} = reservationsApi;
